import { render, staticRenderFns } from "./PodDownloadButton.vue?vue&type=template&id=4ea36429&"
import script from "./PodDownloadButton.vue?vue&type=script&lang=js&"
export * from "./PodDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports